import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { Badge, GenerateBadgeRequest, RegisterBadgeRequest, TemporaryBadgeCandidates,
  TemporaryBadgeIssueRequest, TemporaryBadgeVerificationRequest } from '../_models/badge.model';

@Injectable({ providedIn: 'root' })
export class BadgeService {
  private readonly httpNoInterceptors: HttpClient;

  constructor(private http: HttpClient, httpBackend: HttpBackend) {
    this.httpNoInterceptors = new HttpClient(httpBackend);
  }

  registerBadge(req: RegisterBadgeRequest) {
    return firstValueFrom(
      this.http.post<Badge>(`${environment.localApiUrl}auth/Badges`, req)
    );
  }

  generateBadge(req: GenerateBadgeRequest) {
    return firstValueFrom(
      this.http.post<Badge>(`${environment.localApiUrl}auth/Badges/generate`, req)
    );
  }

  getTemporaryBadgeCandidates(req: TemporaryBadgeVerificationRequest) {
    return firstValueFrom(
      this.httpNoInterceptors.post<TemporaryBadgeCandidates>(
        `${environment.localApiUrl}auth/Accounts/temporary-badge/eligible`, req)
    );
  }

  issueTemporaryBadge(req: TemporaryBadgeIssueRequest) {
    return firstValueFrom(
      this.httpNoInterceptors.post<Badge>(
        `${environment.localApiUrl}auth/Accounts/temporary-badge/generate`, req)
    );
  }

  listBadgesByOperatore(operatoreId: number) {
    return firstValueFrom(
      this.http.get<Badge[]>(`${environment.localApiUrl}auth/Badges/operatore/${operatoreId}`)
    );
  }

  revokeBadge(id: number) {
    return firstValueFrom(
      this.http.delete<Badge>(`${environment.localApiUrl}auth/Badges/${id}`)
    );
  }

  deleteRevokedBadge(id: number) {
    return firstValueFrom(
      this.http.delete<void>(`${environment.localApiUrl}auth/Badges/${id}/permanent`)
    );
  }
}
